import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps';
import {Tabs, Tab} from 'vue-tabs-component';
import VueQriously from 'vue-qriously'


// Router
Vue.config.productionTip = false

//Tabs
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

// QRCode
Vue.use(VueQriously)

// Google Maps
Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyDkne_ihK37Lb7IMLjalWpfAJ3HxM_KfgY",
		library: "places"
	},
});

// Animations

// Start App
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')